// HOW THE CLIENT IS PAYING (2026-09-23).
//
// Cue at Piercinks (Miami FL), replying to Chris at 12:33pm ET: "is there a way to add a line for a form of
// payment? We usually have the client check off if they are paying cash, credit card or other." So a shop can
// turn on one question, "How are you paying today?", with three choices: Cash · Card · Other.
//
// It is the price question's shape (TW-0154, `public_data.ask_price`) with ONE difference: once the shop turns
// it on, the client picks one before signing. Form.tsx refuses its own submit without a pick, in the client's
// language, the way it refuses an unticked terms box; the API never refuses a signing over it
// (services/waiver-api/consolidated_api/common.py payment_method_answered).
//
// THE THREE ARE CODES, never words: the form posts `paymentMethod` as exactly one of them, the API stores it on
// the waiver row as `payment_method`, and every reader turns the code into its own words (i18n.ts here; "Paying
// by: Card" on the signed waiver). "Card" and not "Credit card": a debit card is a card too. No default.

export const PAYMENT_METHODS = ["cash", "card", "other"] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

/** One of the three codes, exactly. The API reads the same three the same way (common.clean_payment_method). */
export function isPaymentMethod(value: unknown): value is PaymentMethod {
  return typeof value === "string" && (PAYMENT_METHODS as readonly string[]).includes(value);
}

/** Does this shop ask? Only a literal true on `public_data.ask_payment_method`: this question GATES the submit, so
 *  a stray "true" on a hand-written row reads as off, and the API reads it the same way
 *  (common.ask_payment_method_of). Off for every shop that never answered, which is every shop before today. */
export function asksPaymentMethod(publicData?: { ask_payment_method?: unknown } | null): boolean {
  return publicData?.ask_payment_method === true;
}
